<template>
  <div class="team-info">
    <Detail v-if="model" :showUser="showUser" :breadcrumbs="breadcrumbs"></Detail>
    <commonTable v-else tableHead="teaminfo" :apiUrl="{ url: 'team', methods: 'teamStatistics' }" ref="commonTable" :height="tableHeight - 102" :params="ruleForm" :selection="false" :tipShow="false" :verifyRemark="false" :defaultSort="{ prop: 'undone_number_of_tasks_sum_working_day', order: 'ascending' }" :config="config">
      <template slot="completed_number_of_tasks" slot-scope="row">
        <progressFlow :complateNumber="row.data.total_number_of_tasks" :countNumber="row.data.completed_number_of_tasks" />
      </template>
      <template slot="realname" slot-scope="dataset">
        <p class="setCellStyle"  @click="findTask(dataset.data)">
          <Myavatar :userName="dataset.data.realname" width="28px" height="28px" :imgUrl="dataset.data.user_avatar">{{ dataset.data.realname }}</Myavatar>
        </p>
      </template>
      <template slot="projects_with_the_most_undone_tasks.title" slot-scope="dataset">
        <p v-if="dataset.data.projects_with_the_most_undone_tasks && dataset.data.projects_with_the_most_undone_tasks.title" @click="toProjrct(dataset.data.projects_with_the_most_undone_tasks.project_id, dataset.data)"><i class="icon iconfont iconicon_project_list_task"></i>{{ dataset.data.projects_with_the_most_undone_tasks.title }}</p>
        <p v-else>-</p>
      </template>
      <template slot="projects_with_the_most_completed_tasks.title" slot-scope="dataset">
        <p v-if="dataset.data.projects_with_the_most_completed_tasks && dataset.data.projects_with_the_most_completed_tasks.title" @click="toProjrct(dataset.data.projects_with_the_most_completed_tasks.project_id, dataset.data)"><i class="icon iconfont iconicon_project_list_task"></i>{{ dataset.data.projects_with_the_most_completed_tasks.title }}</p>
        <p v-else>-</p>
      </template>
    </commonTable>
  </div>
</template>
<script>
import api from "@/services/api/team/team";
import { mapActions, mapState, mapMutations } from "vuex";
import tableTag from "@/components/tableTag";
import progressFlow from "@/components/progress";
import Detail from './detail'
import bus from '@/bus'
export default {
  props: ["checkNode"],
  components: {
    tableTag,
    progressFlow,
    Detail
  },
  data() {
    let _this = this;
    return {
      dataset: [],
      ruleForm: {
        depart_id: 0,
      },
      selectItem: {},
      loading: false,
      config: {
        setCellStyle: _this.setCellStyle,
      },
      model: '',
      breadcrumbs: []
    };
  },
  computed: {
    ...mapState("layout/layout", {
      tableHeight: (state) => state.tableHeight,
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    checkNode: {
      handler() {
        if(!this.checkNode) return
        this.selectItem = this.checkNode ? this.checkNode.data : {};
        this.ruleForm.depart_id = this.selectItem.depart_id || 0;
        this.model = ''
        this.getBreadcrumbs()
        this.$nextTick(() => {
          this.getTeamInfo()
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    bus.$on('selectDepart', item => {
      this.selectItem = this.checkNode ? this.checkNode.data : {};
      this.ruleForm.depart_id = this.selectItem.depart_id || 0;
      this.model = ''
      this.getBreadcrumbs()
      this.getTeamInfo()
    })
  },
  methods: {
    ...mapMutations("team/team", ["SET_TASKMEANDATA"]),
    getBreadcrumbs() {
      let node = this.checkNode
      this.breadcrumbs = []
      while (node && node.level > 0) {
        this.breadcrumbs.unshift(node)
        node = node.parent
      }
      console.log(node, this.breadcrumbs)
    },
    getTeamInfo() {
      this.$refs?.commonTable?.getTableList();
    },
    setCellStyle(data) {
      return this.userInfo.uid === data.uid || data.manage_employee_permission;
    },
    findTask(data) {
      if (!data.manage_employee_permission) return;
      if (this.userInfo.uid === data.uid) {
        this.$router.push("/mine");
      } else {
        this.SET_TASKMEANDATA({ uid: data.uid, realname: data.realname });
        this.$router.push("/mine?type=1");
      }
    },
    toProjrct(id, data) {
      if (this.userInfo.uid === data.uid || this.selectItem.manage_data_permission) {
        this.$router.push("/task?isTabShow=true&projectId=" + id);
      }
    },
    findTask(data) {
      console.log(data)
      if (this.userInfo.uid === data.uid) {
        this.$router.push('/mine')
      } else if (data.manage_employee_permission) {
        this.showUser = data
        this.model = 'Detail'
        this.breadcrumbs.push({ data: { name: data.realname } })
      }
    }
  },
};
</script>
<style lang="scss">
.team-info{
  .iconicon_project_list_task{
    color:#75748E;
    font-size: 14px;
    margin-right:6px;
  }
  .is-premiss{
    cursor: pointer;
    :hover{
      color:$color-active;
    }
  }
    .setCellStyle {
      cursor: pointer;

      &:hover {
        .name-txt {
          color: $color-active;
        }
      }
    }
  .beard-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 0 24px 0;
    height: 32px;
  }
}
</style>
